"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewInAdaOrder = exports.getViewInAdaConvertToPaid = exports.getViewInAdaDomain = exports.getViewInAdaEntitlementConfigLicense = exports.getViewInAdaEntitlementWithId = exports.getViewInAdaAccountUrl = void 0;
const getViewInAdaAccountUrl = (baseUrl, id) => {
    if (id && baseUrl) {
        return `${baseUrl}/ViewAccount.jspa?accountId=${encodeURIComponent(id)}`;
    }
    return '';
};
exports.getViewInAdaAccountUrl = getViewInAdaAccountUrl;
const getViewInAdaEntitlementWithId = (baseUrl, id) => {
    if (id && baseUrl) {
        return `${baseUrl}/ViewAccount.jspa?externalUuid=${encodeURIComponent(id)}`;
    }
    return '';
};
exports.getViewInAdaEntitlementWithId = getViewInAdaEntitlementWithId;
const getViewInAdaEntitlementConfigLicense = (baseUrl, id) => {
    if (id && baseUrl) {
        return `${baseUrl}/app/#/account/${encodeURIComponent(id)}/configure-license`;
    }
    return '';
};
exports.getViewInAdaEntitlementConfigLicense = getViewInAdaEntitlementConfigLicense;
const getViewInAdaDomain = (baseUrl, domain) => {
    if (domain && baseUrl) {
        return `${baseUrl}/UserBrowser.jspa?emailFilter=${encodeURIComponent(`@${domain}`)}`;
    }
    return '';
};
exports.getViewInAdaDomain = getViewInAdaDomain;
const getViewInAdaConvertToPaid = (baseUrl, id) => {
    if (id && baseUrl) {
        return `${baseUrl}/app/#/account/${encodeURIComponent(id)}/configure-ondemand`;
    }
    return '';
};
exports.getViewInAdaConvertToPaid = getViewInAdaConvertToPaid;
const getViewInAdaOrder = (baseUrl, id) => {
    if (id && baseUrl) {
        return `${baseUrl}/ViewOrder.jspa?orderId=${encodeURIComponent(id)}`;
    }
    return '';
};
exports.getViewInAdaOrder = getViewInAdaOrder;
